'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.possibilities = exports.icons = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = getIcon;

var _add = require('./add');

var _add2 = _interopRequireDefault(_add);

var _dropdownCaret = require('./dropdown-caret');

var _dropdownCaret2 = _interopRequireDefault(_dropdownCaret);

var _edit = require('./edit');

var _edit2 = _interopRequireDefault(_edit);

var _help = require('./help');

var _help2 = _interopRequireDefault(_help);

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _issue = require('./issue');

var _issue2 = _interopRequireDefault(_issue);

var _leave = require('./leave');

var _leave2 = _interopRequireDefault(_leave);

var _location = require('./location');

var _location2 = _interopRequireDefault(_location);

var _remove = require('./remove');

var _remove2 = _interopRequireDefault(_remove);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _selectedCheck = require('./selected-check');

var _selectedCheck2 = _interopRequireDefault(_selectedCheck);

var _selectedRadio = require('./selected-radio');

var _selectedRadio2 = _interopRequireDefault(_selectedRadio);

var _selectedTick = require('./selected-tick');

var _selectedTick2 = _interopRequireDefault(_selectedTick);

var _settings = require('./settings');

var _settings2 = _interopRequireDefault(_settings);

var _success = require('./success');

var _success2 = _interopRequireDefault(_success);

var _tag = require('./tag');

var _tag2 = _interopRequireDefault(_tag);

var _time = require('./time');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var icons = exports.icons = {
  add: _add2.default,
  dropdown: _dropdownCaret2.default,
  edit: _edit2.default,
  help: _help2.default,
  info: _info2.default,
  issue: _issue2.default,
  leave: _leave2.default,
  location: _location2.default,
  remove: _remove2.default,
  search: _search2.default,
  check: _selectedCheck2.default,
  radio: _selectedRadio2.default,
  tick: _selectedTick2.default,
  settings: _settings2.default,
  success: _success2.default,
  tag: _tag2.default,
  time: _time2.default
};

var possibilities = exports.possibilities = Object.entries(icons).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      _ref2$ = _ref2[1],
      iconName = _ref2$.name,
      aliases = _ref2$.aliases;

  var options = _defineProperty({}, iconName, name);
  aliases.forEach(function (alias) {
    options[alias] = name;
  });
  return options;
}).reduce(function (acc, curr) {
  return _extends({}, acc, curr);
});

function getIcon(icon) {
  var iconName = possibilities[icon];
  if (!iconName) {
    throw new Error('Icon ' + icon + ' is not a valid icon');
  }
  return icons[iconName];
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/index.js
// module id = 1589
// module chunks = 0